import { UUID } from '@macs-frontend/core/utils/uuid';
import { Unit } from './role.model';

export interface BaseRole {
  uuid: UUID;
  name: string;
  code: string;
  information?: string;
  permissions: string[];
  billablePrice?: number;
  type: RoleType;
  priority: number;
}

export interface Role extends BaseRole {
  units: Unit[];
}

export enum RoleType {
  Company = 'COMPANY',
  Project = 'PROJECT',
  Client = 'CLIENT',
}
